import React from 'react';
import { Logo } from './Logo';
export const Footer = () => {
  return <footer className="w-full border-t border-white/10 px-6 py-12 md:px-12 md:py-16 bg-black relative" data-id="element-11">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom,rgba(255,255,255,0.03),transparent_70%)]" data-id="element-12"></div>
      <div className="max-w-7xl mx-auto relative" data-id="element-13">
        <div className="flex flex-col md:flex-row justify-between items-start mb-12" data-id="element-14">
          <div className="mb-8 md:mb-0" data-id="element-15">
            <Logo size="small" data-id="element-16" />
            <p className="text-zinc-400 mt-4 max-w-xs" data-id="element-17">
              Preserving humanity's essence through proprietary AI technology
              since 2023.
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8" data-id="element-18">
            <div data-id="element-19">
              <h4 className="text-sm font-medium mb-4 text-white/70" data-id="element-20">
                Services
              </h4>
              <ul className="space-y-2 text-sm text-zinc-400" data-id="element-21">
                <li data-id="element-22">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-23">
                    Essence Tier
                  </a>
                </li>
                <li data-id="element-24">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-25">
                    Legacy Tier
                  </a>
                </li>
                <li data-id="element-26">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-27">
                    Immortal Tier
                  </a>
                </li>
                <li data-id="element-28">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-29">
                    Custom Solutions
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-30">
              <h4 className="text-sm font-medium mb-4 text-white/70" data-id="element-31">
                Company
              </h4>
              <ul className="space-y-2 text-sm text-zinc-400" data-id="element-32">
                <li data-id="element-33">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-34">
                    About Us
                  </a>
                </li>
                <li data-id="element-35">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-36">
                    Our Process
                  </a>
                </li>
                <li data-id="element-37">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-38">
                    Technology
                  </a>
                </li>
                <li data-id="element-39">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-40">
                    Ethics
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-41">
              <h4 className="text-sm font-medium mb-4 text-white/70" data-id="element-42">Legal</h4>
              <ul className="space-y-2 text-sm text-zinc-400" data-id="element-43">
                <li data-id="element-44">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-45">
                    Privacy Policy
                  </a>
                </li>
                <li data-id="element-46">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-47">
                    Terms of Service
                  </a>
                </li>
                <li data-id="element-48">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-49">
                    Data Security
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-50">
          <p className="text-sm text-zinc-500 mb-4 md:mb-0" data-id="element-51">
            © 2023 Scion Technology. All rights reserved.
          </p>
          <p className="text-sm text-zinc-500" data-id="element-52">
            By invitation only.{' '}
            <span className="text-white hover:text-zinc-300 transition-colors cursor-pointer" data-id="element-53">
              Request access
            </span>
          </p>
        </div>
      </div>
    </footer>;
};